import { Device, Loading, Theme } from '@livecontrol/core-ui';
import type { ScheduledEvent } from '../../graphql';
import { RouterGrid } from './router-grid';
import { RouterStack } from './router-stack';
import { useLocationsAirtable } from 'libs/scheduler/store/src/location';

export const Routers = ({
  scheduledEvent,
  routersData
}: {
  scheduledEvent?: ScheduledEvent;
  routersData?: Array<{
    id: string;
    name?: string;
    status?: string;
  }>;
}): React.ReactElement => {
  const viewport = Theme.useViewport();

  if (!scheduledEvent) {
    return <Loading isOldVersion={true}/>;
  }

  const { airtableLocations } = useLocationsAirtable(scheduledEvent?.location?.user?.id!)

  const airtableLocation = airtableLocations ? airtableLocations.find(q=> q.secondary_id === scheduledEvent?.location?.secondary_id) : undefined

  const routers = routersData ?? [];

  return (
    <div className='text-white'>
      <h2 className='mt-24px mb-16px'>
        Hardware
        { airtableLocation && (
          <a
            className='text-white font-weight-bold text-left m-0'
            href={`https://airtable.com/app410qBt4fyyY6PI/tbl03DjPs7Nmu5zmB/viwxWWXxxHlBFtMpI/${airtableLocation?.id}`}
            target='_blank'
            rel='noreferrer'
          >
            {' - Airtable link'} <i className='far fa-external-link ml-4px' />
          </a>
        )}

      </h2>
      {Device.isMobile(viewport) ? (
        <RouterStack
          routers={routers}
        />
      ) : (
        <RouterGrid
        routers={routers}
        />
      )}
    </div>
  );
};
